import {Component, OnDestroy, OnInit, Input, Injector} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventManager, AccountService } from 'src/app/core';
import { ProductService } from '../../product.service';
import { ToastrService } from 'ngx-toastr';
import { ManageComponent } from 'src/app/shared/components/manage.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Constant } from 'src/app/core/constant';

@Component({
  selector: 'app-gold-list',
  templateUrl: './gold-list.component.html',
  styleUrls: ['./gold-list.component.scss']
})
export class GoldListComponent extends ManageComponent implements OnInit, OnDestroy {
  @Input() title: any;
  @Input() list?: any[];
  @Input() queryParams: any = {};
  @Input() searchParams: any = {};
  setting: any = {};
  constructor(
  public injector: Injector,
    public eventManager: EventManager,
    public router: Router,
    private productService: ProductService,
    public modalService: NzModalService,
    private toastService: ToastrService
  ) {
    super(eventManager, modalService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.executeCallAPI();
  }
  loadAll(req?: any) {
    this.queryParams.searchParams.typeCodes = [ Constant.CODE_GOLD];
    req = req || this.queryParams;
    this.list = [];
    return this.productService.queryProducts(req)
    .subscribe(this.onResponse.bind(this));
  }
  approve(id) {
    this.router.navigate(['products/gold/approve/' + id]);
  }
  edit(id) {
    this.router.navigate(['products/gold/edit/' + id]);
  }
  delete() {
    const body = {
      statusCode: 'PRODUCT_HIDDEN'
    }
    this.productService.hidden(this.selectedItem.id, body)
    .subscribe((res) => {
      this.toastService.success('Ẩn Sản Phẩm Thành Công !');
      this.eventManager.broadcast({
        name: 'load-page',
        content: {
          page:  this.queryParams.page
        }
      });
    });
  }
  confirmDelete(selectedItem) {
    this.confirmAction(selectedItem, `Bạn chắc chắn muốn ẩn sản phẩm : ${selectedItem.name}`, this.delete.bind(this));
  }
}
